import { CSSProperties } from "react";

interface IconProps {
  size?: number;
  style?: CSSProperties;
}

function createIcon(iconName: string) {
  return ({ size = 16, style }: IconProps) =>
    IconImage(iconName, size, style);
}

export const PCICard = createIcon("win95icons/SETUPX.DLL_14_5");
export const IExploreFile = createIcon("win95icons/iexplore_32545");
export const IExploreFileError = createIcon("win95icons/webcheck_402");
export const IExploreFileLink = createIcon("win95icons/mshtml_2664");
export const IExploreFileHome = createIcon("win95icons/iexplore_32536");
export const IExploreClickPower = createIcon("win95icons/icwoobe_200");
export const IExploreReloadFile = createIcon("win95icons/conf_192");
export const IExploreGoInactive = createIcon("win95icons/browseui_290");
export const IExploreGoActive = createIcon("win95icons/browseui_291");
export const IExploreHTMLFile = createIcon("win95icons/iexplore_32537");

export default function IconImage(iconName: string, size: number = 16, style?: CSSProperties) {
  return (
    <img
      src={`./${iconName}.ico`}
      alt={`${iconName} icon`}
      width={size}
      height={size}
      style={{
        objectFit: "contain",
        imageRendering: "pixelated",
        // no drag
        userSelect: "none",
        pointerEvents: "none",
        ...style,
      }}
    />
  );
}
